const allskillsdata = [
	{
		name: "HTML",

		category: "WEB",
	},
	{
		name: "CSS",
		category: "WEB",
	},
	{
		name: "Bootstrap",
		category: "WEB",
	},
	{
		name: "Javascript",
		category: "PROGRAMMING",
	},
	{
		name: "C++",
		category: "PROGRAMMING",
	},
	{
		name: "ES6",
		category: "WEB",
	},
	{
		name: "React.js",
		category: "WEB",
	},
	{
		name: "Node.js",
		category: "WEB",
	},
	{
		name: "Express.js",
		category: "WEB",
	},
	{
		name: "MongoDB",
		category: "WEB",
	},
	{
		name: "JSON",
		category: "OTHERS",
	},
	{
		name: "Typescript",
		category: "PROGRAMMING",
	},
	{
		name: "Python",
		category: "PROGRAMMING",
	},
	{
		name: "Redux.js",
		category: "OTHERS",
	},
	{
		name: "Gatsby.js",
		category: "WEB",
	},
	{
		name: "NextJS",
		category: "WEB",
	},
	{
		name: "Material-UI",
		category: "WEB",
	},
	{
		name: "SASS",
		category: "WEB",
	},
	{
		name: "Django",
		category: "WEB",
	},
	{
		name: "PostgreSQL",
		category: "WEB",
	},
	{
		name: "Git",
		category: "Tools",
	},
	{
		name: "Create React App",
		category: "Tools",
	},
	{
		name: "NPM",
		category: "Tools",
	},
	{
		name: "VS Code",
		category: "Tools",
	},
	{
		name: "Chrome Dev Tools",
		category: "Tools",
	},
	{
		name: "Firebase",
		category: "Tools",
	},
	{
		name: "Netlify",
		category: "Tools",
	},
	{
		name: "Heroku",
		category: "Tools",
	},
];

export default allskillsdata;
